__turbopack_context__.v({
  "fakeRecaptcha": "styles-module-scss-module__bPM0QW__fakeRecaptcha",
  "recaptcha": "styles-module-scss-module__bPM0QW__recaptcha",
});
